"use client";

import Link from "next/link";
import {
  FaTiktok,
  FaInstagram,
  FaFacebookF,
  FaXTwitter,
  FaGithub,
  FaLinkedin,
} from "react-icons/fa6";
import { glassCardVariants } from "./glass-card";
import Logo from "./logo";
import { siteName } from "@/lib/constants";
import { env } from "@/lib/env";

export default function Footer() {
  const YOUR_WHATSAPP_NUMBER = env.NEXT_PUBLIC_WHATSAPP_NUMBER; 

  const chatUrl = `https://wa.me/${YOUR_WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi! I came across your portfolio and I'd love to connect. 👋"
  )}`;
  
  const socials = [
    {
      href: "https://www.facebook.com/ooluoko",
      label: "Facebook",
      icon: FaFacebookF,
    },
    {
      href: "https://www.instagram.com/oluok_o",
      label: "Instagram",
      icon: FaInstagram,
    },
    {
      href: "https://www.tiktok.com/@oluok_o",
      label: "TikTok",
      icon: FaTiktok,
    },
    { href: "https://x.com/@oluok_o", label: "Twitter", icon: FaXTwitter },
  ];

  const briansSocials = [
    {
      href: "https://www.facebook.com/ooluoko",
      label: "Facebook",
      icon: FaFacebookF,
    },
    { href: "https://github.com/oluoko", label: "Github", icon: FaGithub },
    {
      href: "https://instagram.com/oluok_o",
      label: "Instagram",
      icon: FaInstagram,
    },
    {
      href: "https://www.linkedin.com/in/brianoluoko",
      label: "Linkedin",
      icon: FaLinkedin,
    },
    {
      href: "https://tiktok.com/@oluok_o",
      label: "Tiktok",
      icon: FaTiktok,
    },
    { href: "https://x.com/@oluok_o", label: "Twitter", icon: FaXTwitter },
  ];
  return (
    <div
      className={glassCardVariants({
        className:
          "overflow-hidden  flex flex-col justify-center items-center py-5 p-2 md:px-10 text-foreground/85 mb-15 md:mb-6",
      })}
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 w-full h-10/12">
        <div className="grid my-4 gap-2 md:my-2 mx-3 md:mx-6 content-start h-full">
          <Logo
            altText=" Full-Stack Developer | UI/UX Designer "
            className="w-full"
          />

          <span className=" text-xs">
            Copyrights © {new Date().getFullYear()}
            <Link
              href="/"
              className="text-foreground hover:text-primary text-lg md:text-xl font-black hover:underline"
            >
              {"  "} {siteName} {"  "}
            </Link>
          </span>

          <span>All Rights Reserved</span>
        </div>

        <div className="grid my-4 gap-2 md:my-2 mx-3 md:mx-6 content-start h-full">
          <h3 className="text-xl md:text-2xl font-bold  mb-4 ">
            Write to my email:
          </h3>
          <p className="mb-2">
            For any inquiries or feedback write to me at:{" "}
            <a
              href={`mailto:${env.NEXT_PUBLIC_CONTACT_EMAIL}`}
              className="mb-2"
            >
              <span className=" hover:text-primary hover:underline">
                {env.NEXT_PUBLIC_CONTACT_EMAIL}
              </span>
            </a>
          </p>

          <h3 className="text-xl md:text-2xl font-bold  mb-4 ">Quick Access</h3>
          <div className="grid grid-cols-2 gap-2">
            <Link href="/">
              <span className=" hover:text-primary hover:underline">Home</span>
            </Link>
            <Link href={chatUrl}>
              <span className=" hover:text-primary hover:underline">
                Send me a message
              </span>
            </Link>

            <Link href="/terms-and-conditions">
              <span className=" hover:text-primary hover:underline">
                Ts & Cs
              </span>
            </Link>
            <Link href="/privacy-policy">
              <span className=" hover:text-primary hover:underline">
                Privacy Policy
              </span>
            </Link>
          </div>
        </div>

        <div className="grid my-4 gap-2 md:my-2 mx-3 md:mx-6 content-start  h-full">
          <h3 className="text-xl md:text-2xl font-bold  mb-4 ">Socials:</h3>
          <p className="mb-2 ">
            Reach out or follow me on any of my social platforms, for any
            queries or suggestions.
          </p>
          <div className="w-full flex gap-2">
            {briansSocials.map((social) => (
              <Link href={social.href} key={social.href} target="_blank">
                <div className="rounded-full border hover:text-primary hover:underline hover:border-primary border-slate-400/80 size-7.5 p-1.25">
                  <social.icon className="size-full " />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
